<template>
  <div class="mobile book" :style="{ transform: `scale(${state.scaleRate}) translate(-50%, -50%)`, transformOrigin: 'top left' }">
    <div 
      class="page-container"
      :class="{
        'rotating-left': state.isRotating && state.rotationDirection === 'left',
        'rotating-right': state.isRotating && state.rotationDirection === 'right'
      }"
    >
      <div class="left-page" :class="{ 'fading': state.isFading }">
        <div class="page-content" :class="`page-content-${index}`" v-for="(item, index) in state.currPageData.leftData" :key="index">
          <template v-if="state.currPage === 1">
            <div class="title" :class="locale">
              {{ $t('mwr.stats.infos.page-1-left-title') }}
            </div>
            <div class="desc">
              {{ $t('mwr.stats.infos.page-1-left-desc') }}
            </div>
            <div class="nickname desc">
              [{{ mwrData.cpUserInfo.cpNickName || '--' }}]
            </div>
            <div class="uid desc">
              UID:{{ mwrData.cpUserInfo.cpUserId || '--' }}
            </div>
          </template>
          <template v-if="state.currPage === 2">
            <div class="title" :class="locale">
              {{ $t('mwr.stats.infos.page-2-left-title') }}
            </div>
            <div class="sub-desc">
              {{ $t('mwr.stats.infos.alwaysPlayMode') }}:
            </div>
            <div class="sub-stats">
              [{{ mwrData.statsData.alwaysPlayMode ? $t(`mwr.stats.infos.modeType-${getModeNum(mwrData.statsData.alwaysPlayMode)}`) : '--' }}]
            </div>
            <!-- <div class="sub-desc">
              {{ $t('mwr.stats.infos.alwaysPlayModeTime') }}:
            </div>
            <div class="sub-stats">
              [{{ mwrData.statsData.alwaysPlayModeTime }}]
            </div> -->
            <div class="sub-desc">
              {{ $t('mwr.stats.infos.maxRankScore') }}:
            </div>
            <div class="sub-stats">
              [{{ getHighestRankInfo(mwrData.statsData, locale)?.name || '--' }}]
              <!-- [{{ mwrData.statsData.maxRankScore ? mwrData.statsData.maxRankScore : '--' }}] -->
            </div>
            
            <div class="sub-desc">
              {{ $t('mwr.stats.infos.maxLongWinningCount') }}:
            </div>
            <div class="sub-stats">
              [{{ mwrData.statsData.maxLongWinningCount || '--' }}]
            </div>
            <div class="sub-desc">
              {{ $t('mwr.stats.infos.topFriendId') }}:
            </div>
            <div class="sub-stats">
              [{{ mwrData.statsData.topFriendNickname ? mwrData.statsData.topFriendNickname : '--' }}]
            </div>
          </template>
          <template v-if="state.currPage === 3">
            <div class="left-chenghao-container">
              <div class="left-chenghao-img-wrap">
                <div class="left-chenghao-img" :class="state?.mainChenghao?.keyName"></div>
              </div>
              <div class="left-chenghao-name" :class="locale">
                {{ mwrData.cpUserInfo.cpNickName }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="right-page" :class="{ 'fading': state.isFading }">
        <div class="page-content" :class="`page-content-${index}`" v-for="(item, index) in state.currPageData.rightData" :key="index">
          <template v-if="state.currPage === 1">
            <div class="title" :class="locale">
              {{ $t('mwr.stats.infos.page-1-right-title') }}
            </div>
            <div class="stats">
              [{{ secondToHours(mwrData.statsData.totalGameTime) || '--' }} {{ $t('mwr.stats.infos.hour') }}]
            </div>
            <div class="desc">
              [{{ $t('mwr.stats.infos.totalGameTime') }}]
            </div>
            <div class="stats">
              [{{ mwrData.statsData.totalKillCount || '--' }}]
            </div>
            <div class="desc">
              [{{ $t('mwr.stats.infos.totalKillCount') }}]
            </div>
          </template>
          <template v-if="state.currPage === 2">
            <div class="title" :class="locale">
              {{ $t('mwr.stats.infos.page-2-right-title') }}
            </div>
            <div class="sub-desc">
              {{ $t('mwr.stats.infos.maxWeaponId') }}:
            </div>
            <div class="sub-stats">
              [{{ getWeaponName(mwrData.statsData.maxWeaponId, locale) || '--' }}]
            </div>
            <div class="sub-desc">
              {{ $t('mwr.stats.infos.maxLongLoginDays') }}:
            </div>
            <div class="sub-stats">
              [{{ mwrData.statsData.maxLongLoginDays || '--' }} {{ $t('mwr.stats.infos.day') }}]
            </div>
            <div class="sub-desc">
              {{ $t('mwr.stats.infos.totalWeaponCount') }}:
            </div>
            <div class="sub-stats">
              [{{ mwrData.statsData.totalWeaponCount || '--' }}]
            </div>
            <div class="sub-desc">
              {{ $t('mwr.stats.infos.totalAvtCount') }}:
            </div>
            <div class="sub-stats">
              [{{ mwrData.statsData.totalAvtCount || '--' }}]
            </div>
          </template>
          <template v-if="state.currPage === 3">
            <div v-for="item in CHENGHAO_OPTIONS" :key="item.keyName">
              <RightChenghao v-show="calcChenghaoVisible(item)" :keyName="item.keyName" />
            </div>
          </template>
        </div>
      </div>
      <div class="roles" v-show="!props.saving">
        <div class="left-role"></div>
        <div class="right-role"></div>
      </div>
    </div>
    <div class="btns" v-show="!props.saving">
      <div
        class="btn-prev" 
        @click="handlePrevPage"
        :class="{ disabled: state.isRotating || state.currPage <= 1 }"
      >
        <!-- 上一页 -->
      </div>
      <div 
        class="btn-next" 
        @click="handleNextPage"
        :class="{ disabled: state.isRotating || state.currPage >= Math.ceil(props.bookData.length / 2) }"
      >
        <!-- 下一页 -->
      </div>
    </div>
    
  </div>
</template>

<script setup>
/* eslint-disable */
import { defineProps, ref, computed, onMounted, reactive, inject } from 'vue'
import RightChenghao from '../rightChenghao/index.vue'
import { CHENGHAO_OPTIONS, getWeaponTypeId, getModeNum } from '../../chenghao'
import { getWeaponName } from '../../weapon'
import { useI18n } from 'vue-i18n'
import { getHighestRankInfo } from './duanwei'
const { locale } = useI18n()
const mwrData = inject('mwrData')
const props = defineProps({
  bookData: {
    type: Array,
    required: true
  },
  saving: {
    type: Boolean,
    required: true
  }
})

const state = reactive({
  scaleRate: 1,
  lock: false,
  currPage: 1,
  isRotating: false,
  rotationDirection: 'right', // 'left' or 'right'
  isFading: false, // 控制内容淡入淡出
  currPageData: {
    leftData: [],
    rightData: [],
  },
  newPageData: {
    leftData: [],
    rightData: [],
  },
  mainChenghao: computed(() => calcMainChenghao()),
})

// 按16:9的比例计算缩放比例
const calcScaleRate = () => {
  const screenWidth = window.innerWidth
  const screenHeight = window.innerHeight
  if (screenHeight > screenWidth) {
    return 1
  }
  const scaleRate = screenHeight / screenWidth * 16 / 9

  if (scaleRate > 1) {
    return 1
  }
  if (scaleRate < 0.6) {
    return 0.6
  }
  return scaleRate
}
onMounted(() => {
  state.scaleRate = calcScaleRate()
})

// 时间转成小时，有小数就进一位，保留整数
const secondToHours = (seconds = 0) => {
  return Math.ceil(seconds / 3600) || 0
}

const calcChenghaoVisible = (item) => {
  if (!['modeID', 'weaponType'].includes(item.pkeyName)) {
    return mwrData.statsData.userTitle[item.keyName] === 1
  }
  if (item.pkeyName === 'weaponType') {
    const weaponTypeId = getWeaponTypeId(mwrData.statsData.userTitle.weaponType)
    const keyName = `weaponType-${weaponTypeId}`
    if (item.keyName === keyName) {
      return true
    }
    return false
  }
  if (item.pkeyName === 'modeID') {
    const modeNum = getModeNum(mwrData.statsData.userTitle.modeID)
    const keyName = `modeID-${modeNum}`
    if (item.keyName === keyName) {
      return true
    }
    return false
  }
  return false
}

const calcMainChenghao = () => {
  const showOptions = CHENGHAO_OPTIONS.filter(item => calcChenghaoVisible(item))
  if (!showOptions.length) {
    return null
  }
  const randomIndex = Math.floor(Math.random() * showOptions.length)
  return showOptions[randomIndex]
}

onMounted(() => {
  state.currPageData = getPageData(state.currPage)
})

const getPageData = (page) => {
  const leftPageIndex = page * 2 - 1
  const rightPageIndex = page * 2
  const leftPageData = props.bookData.find(item => item.page === leftPageIndex)
  const rightPageData = props.bookData.find(item => item.page === rightPageIndex)
  return {
    leftData: leftPageData?.data || [],
    rightData: rightPageData?.data || [],
  }
}

const handlePrevPage = () => {
  if (state.currPage > 1 && !state.isRotating) {
    state.isRotating = true
    state.rotationDirection = 'left'
    
    // 在旋转到90度左右时开始淡出（约200ms）
    setTimeout(() => {
      state.isFading = true
    }, 200)
    
    // 在旋转到180度时更新数据（中间点，400ms）
    setTimeout(() => {
      state.currPage--
      state.currPageData = getPageData(state.currPage)
    }, 400)
    
    // 在旋转到270度左右时开始淡入（约600ms）
    setTimeout(() => {
      state.isFading = false
    }, 600)
    
    // 动画完成后重置状态
    setTimeout(() => {
      state.isRotating = false
    }, 800) // 动画总时长
  }
}

const handleNextPage = () => {
  const maxPage = Math.ceil(props.bookData.length / 2)
  if (state.currPage < maxPage && !state.isRotating) {
    state.isRotating = true
    state.rotationDirection = 'right'
    
    // 在旋转到90度左右时开始淡出（约200ms）
    setTimeout(() => {
      state.isFading = true
    }, 200)
    
    // 在旋转到180度时更新数据（中间点，400ms）
    setTimeout(() => {
      state.currPage++
      state.currPageData = getPageData(state.currPage)
    }, 400)
    
    // 在旋转到270度左右时开始淡入（约600ms）
    setTimeout(() => {
      state.isFading = false
    }, 600)
    
    // 动画完成后重置状态
    setTimeout(() => {
      state.isRotating = false
    }, 800) // 动画总时长
  }
}
</script>

<style scoped lang="less" src="./mobile_style.less"></style>